import React from "react";
import { t } from "i18next";
import { useOutletContext } from "react-router";
import ResourceDetailsPage from "src/pages/ResourceDetails/ResourceDetailsPage";

import AddressBlock from "@components/shared/AddressBlock/AddressBlock";
import CollapsibleText from "@components/shared/CollapsibleText/CollapsibleText";
import ContactPerson from "@components/shared/ContactPerson/ContactPerson";
import { getLocationType, locationType } from "@models/services/organisation";
import { userProfile } from "@models/services/user";
import { ContactPersonInfoType } from "@models/shared/shared.model";
import { applyLocalization } from "@services/common.service";

const OrganisationInfo: React.FC = () => {
  const [locationDetails, activeLocation, userProfile, contactDetails]: [
    getLocationType,
    locationType,
    userProfile,
    Array<ContactPersonInfoType>,
  ] = useOutletContext() || [];

  const personName = `${
    userProfile?.profile?.firstName || ""
  } ${userProfile?.profile?.lastName || ""}`;

  const welcomeName = userProfile?.profile?.firstName
    ? personName
    : userProfile?.profile?.companyName || "";

  return (
    <div
      className="tab-content"
      id="pills-tabContent"
      data-testid="organisationInfo-test"
    >
      <div
        className="tab-pane fade show active"
        id="pills-org-info"
        role="tabpanel"
        aria-labelledby="info-tab"
      >
        <div className="fg-tab-content-wrap">
          <div className="container">
            <CollapsibleText
              heading={`${t("welcome")} ${welcomeName}`}
              content={
                applyLocalization(activeLocation?.info?.shortDescription) || ""
              }
              isSlider={true}
              sliderImage={activeLocation?.images}
            />

            {locationDetails?.clubLogo && (
              <div
                className="fg-location-logo "
                data-testid="organisation-clubLogo"
              >
                <img src={locationDetails?.clubLogo} alt="Location logo" />
              </div>
            )}

            <ContactPerson
              contactList={contactDetails}
              isVisible={contactDetails?.length > 0}
              locationId={activeLocation?.id}
            />
            <CollapsibleText
              content={applyLocalization(activeLocation?.info?.aboutus)}
              heading={t("aboutOurOrganization")}
              isSubheading
            />
            <AddressBlock data={activeLocation} />
          </div>
          <ResourceDetailsPage />
        </div>
      </div>
    </div>
  );
};

export default OrganisationInfo;
